import React from 'react';
import { Reveal } from './Reveal';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  intro?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
}
export function SectionHeading({
  eyebrow,
  title,
  intro,
  align = 'left',
  tone = 'light'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <Reveal className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-283" data-mp="3k0ozxapcw6fo">
      {eyebrow && <p className={`mb-4 flex items-center gap-3 text-[11px] uppercase tracking-wordmark ${align === 'center' ? 'justify-center' : ''} ${isDark ? 'text-gold-300' : 'text-gold-700'}`} data-id="element-284" data-mp="bl588g4c2w2q">
          <span className={`h-px w-8 ${isDark ? 'bg-gold-400' : 'bg-gold-500'}`} aria-hidden="true" data-id="element-285" data-mp="6tdj8a0tsyep" />
          {eyebrow}
        </p>}
      <h2 className={`font-display text-3xl leading-[1.15] sm:text-[2.7rem] ${isDark ? 'text-ivory-100' : 'text-forest-700'}`} data-id="element-286" data-mp="uifyjb7zmf61">
        {title}
      </h2>
      {intro && <p className={`mt-5 text-base leading-relaxed ${isDark ? 'text-ivory-200/80' : 'text-muted'}`} data-id="element-287" data-mp="1tb0mgxbjwrhm">{intro}</p>}
    </Reveal>;
}